import { defineStore } from 'pinia'
import axios from 'axios'

export const useChecker = defineStore('checker', {
  state: () => ({
    isLoading: false,
    checker: {},
  }),
  actions: {
    async getOrganization(organizationName) {
      this.isLoading = true
      try {
        const result = await axios.get(`/core/v1/checkers?organization_name=${organizationName}`)
        this.checker.organization = result

        return this.checker.organization
      } catch (err) {
        return err.errors
      }
    },
    async getDomain(domainName) {
      this.isLoading = true
      try {
        const result = await axios.get(`/core/v1/checkers?site_domain=${domainName}`)
        this.checker.domain = result

        return this.checker.domain
      } catch (err) {
        return err.errors
      }
    },
  },
})
